import _ from 'underscore';

import { soundNotification } from '../constants/assets';

let notificationSoundPlaying = false;
let currentAudio;

export function isAudioSupported() {
    return !!global.Audio;
}

function onNotificationPlaying() {
    notificationSoundPlaying = true;
}

function onNotificationPause() {
    notificationSoundPlaying = false;
}

function onNotificationEnded() {
    notificationSoundPlaying = false;
    unloadAudio();
}

function unloadAudio() {
    if (currentAudio) {
        currentAudio.removeEventListener('playing', onNotificationPlaying);
        currentAudio.removeEventListener('pause', onNotificationPause);
        currentAudio.removeEventListener('ended', onNotificationEnded);
        currentAudio = undefined;
    }
}

export function playNotificationSound() {
    if (isAudioSupported() && !notificationSoundPlaying) {
        try {
            currentAudio = new Audio(soundNotification);
            currentAudio.addEventListener('playing', onNotificationPlaying);
            currentAudio.addEventListener('pause', onNotificationPause);
            currentAudio.addEventListener('ended', onNotificationEnded);
            currentAudio.play();
        } catch (e) {
            // Do nothing about it, some browsers won't let us play the sound
            // if it's not initiated by a user action.
        }
    }
}

export const throttleNotificationSound = _.throttle(playNotificationSound, 4000, { trailing: false });

export function stopNotificationSound() {
    if (currentAudio && notificationSoundPlaying) {
        currentAudio.pause();
        unloadAudio();
    }
}
